module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('privacy-service')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10dd662e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/privacyService/PrivacyService.vue
// module id = 1264
// module chunks = 1